import React, { Component } from "react";
import PropTypes from "prop-types";

import "./timeline.scss";
import { IconChevronDown16 } from "../Icons/Icons";
import Button from "../Button/Button";

class Timeline extends Component {
  constructor(props) {
    super(props);

    const { visibleEvents } = this.props;

    this.state = {
      visibleEvents,
    };

    this.handleExpansion = this.handleExpansion.bind(this);
  }

  handleExpansion() {
    const { increments, children } = this.props;
    const { visibleEvents } = this.state;

    this.setState({
      visibleEvents:
        visibleEvents + increments > children.length ? children.length : visibleEvents + increments,
    });
  }

  render() {
    const { className, buttonText, children, id } = this.props;
    const { visibleEvents } = this.state;
    const { toArray } = React.Children;

    const canShowMore = visibleEvents < toArray(children).length;
    const toDisplay = toArray(children).slice(0, visibleEvents);

    return (
      <div className={`timeline ${className}`} id={id}>
        {toDisplay}
        {canShowMore && (
          <Button
            text={buttonText}
            variant="outlined"
            onClick={this.handleExpansion}
            className="timeline__expansion-button u-margin-top-4"
            icon={IconChevronDown16}
            iconPosition="right"
          />
        )}
      </div>
    );
  }
}

Timeline.propTypes = {
  /**
   * number of TimelineEvent components to show by default
   */
  visibleEvents: PropTypes.number.isRequired,
  /**
   * number of TimelineEvent components to show when expanding
   */
  increments: PropTypes.number,
  /**
   * Expand button text
   */
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  id: PropTypes.string,
};

Timeline.defaultProps = {
  className: "",
  increments: 1,
};

export default Timeline;
